import React from "react";
import classNames from "classnames";

import styles from "./LoadingSpinner.module.css";

export interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "md",
  className,
  text,
}) => {
  const containerClasses = classNames(
    styles.container,
    {
      [styles.withText]: text,
    },
    className,
  );

  const spinnerClasses = classNames(styles.spinner, styles[`spinner--${size}`]);

  return (
    <div className={containerClasses}>
      <div className={spinnerClasses} />
      {text && <span className={styles.text}>{text}</span>}
    </div>
  );
};

export { LoadingSpinner };
